import { render, staticRenderFns } from "./tabbed-information.vue?vue&type=template&id=5a349db2&lang=pug&"
import script from "./tabbed-information.vue?vue&type=script&lang=js&"
export * from "./tabbed-information.vue?vue&type=script&lang=js&"
import style0 from "./tabbed-information.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports